import { getToken } from "firebase/messaging";
import { messaging } from "../../Libs/firebaseConfig";

export const requestForToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    try {
      const currentToken = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_PUBLIC_VAPID_KEY,
      });
      if (currentToken) {
        return currentToken;
      }
    } catch (error) {
      console.error("An error occurred while retrieving token.", error);
    }
  }
};
